import type { LatLon } from "./types";

const R = 6371000;
const rad = (d: number) => (d * Math.PI) / 180;

export const haversineM = (a: LatLon, b: LatLon): number => {
  const dLat = rad(b.lat - a.lat);
  const dLon = rad(b.lon - a.lon);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

// Расстояние от точки до ломаной [lat, lon][]. На масштабах поиска (километры)
// хватает локальной равнопромежуточной проекции вокруг самой точки.
export const pointToPolylineM = (p: LatLon, line: [number, number][]): number => {
  if (line.length === 0) return Infinity;
  const kx = R * Math.cos(rad(p.lat)) * (Math.PI / 180);
  const ky = R * (Math.PI / 180);
  const xy = (lat: number, lon: number): [number, number] => [(lon - p.lon) * kx, (lat - p.lat) * ky];
  if (line.length === 1) return Math.hypot(...xy(line[0][0], line[0][1]));
  let best = Infinity;
  for (let i = 0; i < line.length - 1; i++) {
    const [ax, ay] = xy(line[i][0], line[i][1]);
    const [bx, by] = xy(line[i + 1][0], line[i + 1][1]);
    const dx = bx - ax;
    const dy = by - ay;
    const len2 = dx * dx + dy * dy;
    const t = len2 === 0 ? 0 : Math.max(0, Math.min(1, -(ax * dx + ay * dy) / len2));
    best = Math.min(best, Math.hypot(ax + t * dx, ay + t * dy));
  }
  return best;
};

export const formatDistance = (m: number, units: { km: string; m: string }, locale: string): string => {
  if (m < 1000) return `${Math.round(m)} ${units.m}`;
  const km = m / 1000;
  const nf = new Intl.NumberFormat(locale, { maximumFractionDigits: km < 10 ? 1 : 0 });
  return `${nf.format(km)} ${units.km}`;
};
